import React from 'react';
import { styled } from '@mui/material/styles';

import {
  getAudioFile,
  getDirectionImages,
  getInformationImages,
  getTaskImages,
  ITourInsight
} from "@lialo/core/lib/models";
import { createQuizResponseVMsFromTourStop } from '@lialo/core/lib/common';

import Directions from '../../../common/TourContent/Sections/Directions';
import Introduction from '../../../common/TourContent/Sections/Introduction';
import Task from '../../../common/TourContent/Sections/Task';
import Information from '../../../common/TourContent/Sections/Information';
import { Ellipsis } from './Ellipsis';

const PREFIX = 'TourInsight';

const classes = {
  page: `${PREFIX}-page`,
  content: `${PREFIX}-content`,
};

const Root = styled('main')(({ theme }) => ({
  [`& .${classes.page}`]: {
    position: 'relative',
  },

  [`&.${classes.content}`]: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    // overflowY: 'auto', needed when showed in a dialog
  },
}));

interface IProps {
  tourInsight: ITourInsight;
}

const TourInsight = ({ tourInsight }: IProps) => {
  return (
    <Root className={classes.content}>
      <Introduction
        startText={tourInsight.startText}
        images={tourInsight.startImages}
        // Feature: Text-to-speech
        audioSrc={getAudioFile(tourInsight.audioFiles, 'INTRODUCTION')?.url}
      />
      {tourInsight.stops['0'] === undefined && <Ellipsis showDivider={true} />}
      {Object.entries(tourInsight.stops).map(([stopIndex, stop]) => (
        <React.Fragment key={stop.id}>
          <Directions
            images={getDirectionImages(stop)}
            text={stop.directions}
            orderId={stop.orderId ?? 0}
            stopIndex={Number(stopIndex)}
          />
          <Task
            images={getTaskImages(stop)}
            question={stop.task?.question}
            answers={createQuizResponseVMsFromTourStop(stop, false)}
            orderId={stop.orderId ?? 0}
            stopIndex={Number(stopIndex)}
          />
          <Information
            images={getInformationImages(stop)}
            title={stop.title}
            text={stop.information}
            orderId={stop.orderId ?? 0}
            // Feature: Text-to-speech
            audioSrc={getAudioFile(tourInsight.audioFiles, 'INFORMATION', stop.id)?.url}
          />
        </React.Fragment>
      ))}
      <Ellipsis />
    </Root>
  );
};

export default TourInsight;
